export enum DemoPageViewMode {
    table = 'table',
    grid = 'grid',
}
